import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, finalize } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { Category,SubCategory,ChildCategory } from '../_models/';

const baseUrl = `${environment.apiUrl}/category`;
const subCategoryUrl = `${environment.apiUrl}/subcategory`;
const childCategoryUrl = `${environment.apiUrl}/childcategory`;
@Injectable({ providedIn: 'root' })
export class CategoryService {
    private categorySubject: BehaviorSubject<Category>;
    public category: Observable<Category>;
    private subCategorySubject: BehaviorSubject<SubCategory>;
    public subCategory: Observable<SubCategory>;
    private childCategorySubject: BehaviorSubject<ChildCategory>;
    public childCategory: Observable<ChildCategory>;

    constructor(
        private router: Router,
        private http: HttpClient
    ) {
        this.categorySubject = new BehaviorSubject<Category>(null);
        this.category = this.categorySubject.asObservable();
        this.subCategorySubject = new BehaviorSubject<SubCategory>(null);
        this.subCategory = this.subCategorySubject.asObservable();
        this.childCategorySubject = new BehaviorSubject<ChildCategory>(null);
        this.childCategory = this.childCategorySubject.asObservable();
    }

    public get categoryValue(): Category {
        return this.categorySubject.value;
    }
    public get subCategoryValue(): Category {
        return this.subCategorySubject.value;
    }
    public get childCategoryValue(): Category {
        return this.childCategorySubject.value;
    }

    getAll() {
        return this.http.get<Category[]>(baseUrl);
    }
    getCategoryLayer(layer) {
        return this.http.get<Category[]>(`${baseUrl}/layer/${layer}`);
    }
    getCategory(layer) {
        return this.http.get<Category[]>(`${baseUrl}/layer/${layer}`);
    }

    getById(id: string) {
        return this.http.get<Category>(`${baseUrl}/${id}`);
    }
    getSubBysubId(subId: string) {
        return this.http.get<Category>(`${baseUrl}/sub/${subId}`);
    }
    create(params) {
        return this.http.post(baseUrl, params);
    }
    
    update(id, params) {
        return this.http.put(`${baseUrl}/${id}`, params)
            .pipe(map((category: any) => {
                    // publish updated category to subscribers
                    category = { ...this.categoryValue, ...category };
                    this.categorySubject.next(category);
              
                return category;
            }));
    }
    delete(id: string) {
        return this.http.delete(`${baseUrl}/${id}`)
            .pipe(finalize(() => {
            }));
    }
    getAllSubCategory() {
        return this.http.get<Category[]>(subCategoryUrl);
    }
    getAllSubCategoryById(parentId: string) {
        return this.http.get<Category[]>(`${baseUrl}/sub/${parentId}`);
    }
    getAllChildCategoryById(subId: string) {
        return this.http.get<Category[]>(`${baseUrl}/child/${subId}`);
    }
    getSubCategory() {
        return this.http.get<SubCategory[]>(subCategoryUrl);
    }

    getSubById(id: string) {
        return this.http.get<SubCategory>(`${subCategoryUrl}/${id}`);
    }
    
    createSub(params) {
        return this.http.post(`${baseUrl}/sub/`, params);
    }
    
    updateSub(id, params) {
        return this.http.put(`${baseUrl}/sub/${id}`, params)
            .pipe(map((category: any) => {
                    // publish updated category to subscribers
                    category = { ...this.categoryValue, ...category };
                    this.categorySubject.next(category);
              
                return category;
            }));
    }
    deleteSub(id: string) {
        return this.http.delete(`${baseUrl}/sub/${id}`)
            .pipe(finalize(() => {
            }));
    }
    getAllChildCategory() {
        return this.http.get<ChildCategory[]>(childCategoryUrl);
    }
    getChildCategory(sortOrder) {
        return this.http.get<ChildCategory[]>(`${childCategoryUrl}/sortOrder/${sortOrder}`);
    }

    getChildCategoryById(id: string) {
        return this.http.get<ChildCategory>(`${childCategoryUrl}/${id}`);
    }
 
    createChildCateogry(params) {
        return this.http.post(`${baseUrl}/child/`, params);
    }
    
    updateChildCategory(id, params) {
        return this.http.put(`${baseUrl}/child/${id}`, params)
            .pipe(map((category: any) => {
                    // publish updated category to subscribers
                    category = { ...this.categoryValue, ...category };
                    this.categorySubject.next(category);
              
                return category;
            }));
    }
    deleteChildCategory(id: string) {
        return this.http.delete(`${baseUrl}/child/${id}`)
            .pipe(finalize(() => {
            }));
    }
   

    
}